
import IconBtn from "@/components/molecules/IconBtn.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import TableInline from "@/components/atoms/TableInline.vue";
import {defineComponent, PropType} from "vue";
import TradeContractFormatView from "@/components/pages/contract/TradeContractFormat/TradeContractFormatView";
import TableUtil from "@/components/pages/contract/TradeContractList/TableUtil";
import Formatter from "@/utils/Formatter";
import {mapGetters} from "vuex";
import ErrorPopover from "@/components/molecules/ErrorPopover.vue";

export default defineComponent({
  name: 'FormatTable',
  components: {
    ErrorPopover,
    IconBtn, TextFieldLike, TableInline,
  },
  mixins: [
    TableUtil,
    Formatter,
  ],
  props: {
    formats: {
      type: Array as PropType<TradeContractFormatView[]>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: 'auto',
    },
    sortable: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account',
    }),
    defaultSort(): any {
      return this.sortable ? {prop: 'name'} : {};
    }
  }
});
